import { useState } from 'react';
import { Button } from '@jeraisonne/ui';
import type { SchoolLevel } from '@jeraisonne/db';
import { LEVEL_LABEL } from '@/features/demo/types';
import { KitDots, KitScreen, KitSlots, KitStage } from './kit-stage';

/**
 * Le premier écran de la démo, après le choix de la classe : la trousse en grand, vide, qu'on
 * ouvre d'un toucher. Elle annonce ce que la question va apporter — deux Moves, un savoir et un
 * geste — pour que la trousse de l'exercice ne soit pas un meuble de plus à deviner.
 */
export function TrousseScreen({
  level,
  onStart,
  leaving = false,
}: {
  level: SchoolLevel;
  onStart: () => void;
  /** l'exercice est déjà là, dessous : la trousse s'envole s'y poser et l'écran s'efface */
  leaving?: boolean;
}) {
  const [open, setOpen] = useState(false);
  return (
    <KitScreen testId="demo-trousse-screen" overlay={leaving} leaving={leaving}>
      <p className="jr-kit-fade text-xs font-semibold uppercase tracking-[0.16em] text-[#f7d068]">
        Ta trousse · {LEVEL_LABEL[level]}
      </p>
      <h1 className="font-display jr-kit-fade mt-2 text-center text-3xl font-bold leading-tight text-white">
        Voici ta première trousse
      </h1>

      <div className="my-4 flex w-full flex-1 items-center justify-center">
        <KitStage open={open} size={246} leaving={leaving} />
      </div>

      {open ? (
        <div className="jr-kit-fade w-full space-y-4 text-center">
          <KitSlots kinds={['savoir', 'geste']} />
          <p className="text-base leading-relaxed text-white/85">
            Deux sortes de choses s’y rangent :{' '}
            <span className="font-semibold text-[#f7d068]">les savoirs</span> (une formule, un
            théorème) et <span className="font-semibold text-[#a78bf0]">les gestes</span> (ce que tu
            fais sur ton brouillon). Tu en gagnes dans ce problème, et ils te suivent ensuite
            partout.
          </p>
          <Button variant="gold" size="lg" fullWidth onClick={onStart}>
            C’est parti
          </Button>
        </div>
      ) : (
        <div className="jr-kit-fade w-full space-y-4 text-center">
          <p className="text-base leading-relaxed text-white/85">
            Elle est vide. C'est là que tu rangeras ce que tu apprends : les formules à reconnaître
            et les gestes qui font avancer ton brouillon.
          </p>
          <Button variant="gold" size="lg" fullWidth onClick={() => setOpen(true)}>
            Ouvre-la
          </Button>
        </div>
      )}

      <div className="jr-kit-fade mt-5">
        <KitDots step={0} />
      </div>
    </KitScreen>
  );
}
